/* Global context that will be sent with every error log. */
const GLOBAL_CONTEXT = {
    appVersion: '1.0.0',
    environment: process.env.NODE_ENV || 'development',
};

const ErrorLog = {
    log: async (level, message, context = {}) => {
        try {
            const prefix = process.env.REACT_APP_LOCAL || null;
            const combinedContext = { ...GLOBAL_CONTEXT, ...context };
            await fetch(`${process.env.REACT_APP_BACKEND_DOMAIN}/api/error-log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    level,
                    message: (prefix ? prefix+"::" : '') + message,
                    context: combinedContext,
                }),
            });
            console.info(`Logged to server: ${level.toUpperCase()} - ${message}`);
        } catch (error) {
            console.error('Failed to log error to the server:', error);
        }
    },

    debug: (message, context = {}) => {
        ErrorLog.log('debug', message, context);
    },

    info: (message, context = {}) => {
        ErrorLog.log('info', message, context);
    },

    warn: (message, context = {}) => {
        ErrorLog.log('warning', message, context);
    },

    error: (message, context = {}) => {
        ErrorLog.log('error', message, context);
    },
};

export default ErrorLog;
